import { CheqLoader } from '@clickcease/cc-client-components-lib'
import React from 'react'

import { IPsTable } from '../../features/DetailedReport/IPsTable'
import { useBMStore } from '../../stores/useBMStore'

import { DetailedReportWrapper, LoaderWrapper } from './DetailedReport.styled'

interface DetailedReportProps {
  locale?: string
}

export const DetailedReport: React.FC<DetailedReportProps> = ({ locale }) => {
  const domains = useBMStore((state) => state.domains)

  return (
    <DetailedReportWrapper>
      {domains && domains.length > 0 ? (
        <IPsTable locale={locale} />
      ) : (
        <LoaderWrapper>
          <CheqLoader />
        </LoaderWrapper>
      )}
    </DetailedReportWrapper>
  )
}
